<template>
    <div class="device-logs-module">
        <v-row>
            <v-col
                class="white"
            >
                <v-breadcrumbs
                    :items="[
                                {
                                  text: $t('navigation.administration'),
                                  disabled: true,
                                  href: 'breadcrumbs_dashboard',
                                },
                                {
                                  text: $t('navigation.device_logs'),
                                  disabled: true,
                                  href: 'breadcrumbs_dashboard',
                                },
                              ]"
                    class="mt-0 pt-0 pl-4"
                ></v-breadcrumbs>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>

                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="search"
                                    :label="$t('device_log.search')"
                                    append-icon="mdi-magnify"
                                    hide-details
                                    single-line
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" style="padding-bottom: 0">
                                <v-menu
                                    v-model="date_picker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    offset-y
                                    transition="scale-transition"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="dateRange"
                                            :label="$t('tour.date_range')"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dates"
                                                   range
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                    </v-card-title>

                    <v-data-table
                        :footer-props="{'items-per-page-options': [10,20,100],
                        'items-per-page-text': $t('global.rows_per_page')}"
                        :headers="headers"
                        :items="logs"
                        :items-per-page="15"
                        :loading="loading"
                        :loading-text="$t('global.loading_text')"
                        :no-data-text="$t('global.no_data')"
                        :no-results-text="$t('global.no_results_text')"
                        :options.sync="options"
                        :search="search"
                        :server-items-length="total_logs"
                        class="elevation-1"
                        multi-sort
                    >
                        <template v-slot:item.upload_date="{ item }">
                            {{ item.upload_date | moment('L LT') }}
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                :title="$t('device_log.download')"
                                class="mr-2"
                                small
                                @click="downloadLog(item)"
                            >
                                mdi-download
                            </v-icon>

                            <v-icon
                                :title="$t('device_log.delete')"
                                class="mr-2"
                                small
                                @click="openSuppressionDialog(item)"
                            >
                                mdi-trash-can-outline
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="suppression_dialog" max-width="290">
            <v-card elevation="0">
                <v-card-title class="headline">{{ $t('repository.sure') }}</v-card-title>
                <v-card-text>{{ $t('repository.irremediable') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" text @click="suppression_dialog = false">
                        {{ $t('repository.cancel') }}
                    </v-btn>
                    <v-btn color="warning darken-1" text @click="deleteLog()">
                        {{ $t('repository.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _ from 'lodash'
import {DEVICE_LOGS} from "../api";

export default {
    name: "device_logs",
    data() {
        return {
            headers: [
                {text: this.$t('device_log.import_date'), value: 'upload_date', sortable: true},
                {text: this.$t('device_log.guid'), value: 'guid', sortable: true},
                {text: this.$t('device_log.server_path'), value: 'file_path', sortable: false},
                {text: this.$t('device_log.size_ko'), value: 'file_size', sortable: false},
                {text: this.$t('device_log.actions'), value: 'actions', sortable: false},
            ],
            loading: true,
            date_picker: false,
            options: {},
            page: 1,
            total_logs: 0,
            logs: [],
            search: '',
            dates: [],
            lang: 'fr',
            suppression_dialog: false,
            item_to_delete: {}
        }
    },
    mounted() {

    },
    computed: {
        dateRange() {
            if(this.dates && this.dates[0] && this.dates[1]){
                return [this.$moment(this.dates[0]).format('L'), this.$moment(this.dates[1]).format('L')].join(' ➤ ')
            }

            return null
        },
    },
    methods: {
        /**
         * Reset snackbar
         */
        resetSnackbar() {
            this.snackbar_type = null;
            this.snackbar_text = null;
            this.snackbar = false;
        },
        /**
         * Show snackbar
         *
         * @param {string} type
         * @param {string} text
         */
        showSnackbar(type, text) {
            this.snackbar_type = type;
            this.snackbar_text = text;
            this.snackbar = true;
        },
        /**
         * Get users from API
         */
        getLogs() {
            this.loading = true;

            const {sortBy, sortDesc, page, itemsPerPage} = this.options;

            let sort = '';
            if (Array.isArray(sortBy)) {
                _.each(sortBy, (elem, key) => {
                    let order = sortDesc[key] ? '-' : '';
                    sort += order + elem + ',';
                })
            } else {
                let order = sortDesc ? '-' : '';
                sort += order + sortBy;
            }

            this.axios.get(
                DEVICE_LOGS,
                {
                    params: {
                        page,
                        per_page: itemsPerPage,
                        sort,
                        search: this.search,
                        dates: this.dates,
                    }
                }
            ).then((success) => {
                this.logs = success.data.data;
                this.total_logs = success.data.total;
            }).catch(() => {
                this.showSnackbar('error', this.$t('global.error'));
            }).finally(() => {
                this.loading = false;
            })
        },
        openSuppressionDialog(item) {
            this.item_to_delete = item
            this.suppression_dialog = true
        },
        deleteLog() {
            if(this.item_to_delete && this.item_to_delete.id){
                this.loading = true
                this.axios.delete(
                    `${DEVICE_LOGS}/${this.item_to_delete.id}/delete`
                ).then(() => {
                    this.suppression_dialog = false
                    this.item_to_delete = {}
                    this.getLogs()
                }).catch(() => {
                    this.showSnackbar('error', this.$t('global.error'));
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        async downloadLog(item) {
            try {
                const response = await this.axios.get(`${DEVICE_LOGS}/${item.id}/download`, {
                    responseType: 'blob', // Utilise 'blob' pour éviter la corruption
                });

                // Vérifier si la réponse est bien un ZIP et non une erreur HTML/TXT
                if (response.data.type !== "application/zip") {
                    throw new Error("Fichier corrompu ou mauvais type de réponse");
                }

                // Créer un lien de téléchargement
                const fileURL = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = fileURL;

                // Extraire le nom du fichier si possible
                const contentDisposition = response.headers['content-disposition'];
                let fileName = `log_${item.id}.zip`;

                if (contentDisposition) {
                    const matches = contentDisposition.match(/filename="?(.+?)"?$/);
                    if (matches.length > 1) {
                        fileName = matches[1];
                    }
                }

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();

                // Nettoyer après téléchargement
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                console.error("Erreur lors du téléchargement :", error);
                alert("Erreur lors du téléchargement du fichier ZIP");
            }
        }

    },
    watch: {
        options: {
            handler() {
                this.getLogs();
            }
            ,
            deep: true,
        },
        search: _.debounce(function () {
            this.getLogs();
        }, 500),

        dates: {
            handler(dates) {
                if(dates.length > 1){
                    this.getLogs();
                }
            }
            ,
            deep: true,
        }
    }
}
</script>
<style lang="scss">

.device-logs-module {
    .v-breadcrumbs li:last-child a {
        font-size: 1.25rem !important;
        color: rgba(0, 0, 0, .6) !important;
        font-weight: 500;
    }

    .v-list--dense .v-list-item {
        .v-list-item__title,
        .v-list-item__subtitle {
            font-size: 0.9rem;
        }
    }
}
</style>
